/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountsBalances { 
    accountId?: number;
    designation?: string | null;
    currency?: string | null;
    debitBalance?: number;
    debitPlanBalance?: number;
    creditBalance?: number;
    creditPlanBalance?: number;
    part?: number;
}

